module.exports = __webpack_public_path__ + "img/clock-icon.acfdb19b.svg";